"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageContentWithData = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var axios_1 = require("axios");
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var section_ids_1 = require("../../section-ids");
var utils_1 = require("../../utils");
var UsageContent_1 = require("./UsageContent");
var UnsupportedSupplyPoint = function (_a) {
    var _b, _c;
    var data = _a.data;
    var _d = (0, core_1.useComponents)(), Callout = _d.Callout, Heading1 = _d.Heading1, Heading4 = _d.Heading4;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.USAGE_PAGE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.USAGE_NOT_SUPPORTED_CALLOUT, properties: (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c.id = data, _c) },
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "unsupportedMeterSetupPageTitle" })),
                react_1.default.createElement(Callout, null,
                    react_1.default.createElement(Heading4, null,
                        react_1.default.createElement(Copy, { copyKey: "unsupportedMeterSetupTitle" })),
                    react_1.default.createElement(Copy, { copyKey: "unsupportedMeterSetupText" }))))));
};
var Error = function (_a) {
    var _b, _c;
    var isFetching = _a.isFetching, _d = __read(_a.error, 1), usageErrorResponse = _d[0];
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    return isFetching ? (react_1.default.createElement(__1.Loading, null)) : usageErrorResponse instanceof axios_1.AxiosError &&
        ((_b = usageErrorResponse === null || usageErrorResponse === void 0 ? void 0 : usageErrorResponse.response) === null || _b === void 0 ? void 0 : _b.data) ===
            'MULTIPLE_SAME_FUEL_NOT_SUPPORTED' ? (react_1.default.createElement(UnsupportedSupplyPoint, { data: (_c = usageErrorResponse === null || usageErrorResponse === void 0 ? void 0 : usageErrorResponse.response) === null || _c === void 0 ? void 0 : _c.data })) : (react_1.default.createElement(ErrorSection, { alertLevel: "error", id: section_ids_1.USAGE_DATA_ERROR, "data-testid": section_ids_1.USAGE_DATA_ERROR }));
};
var Data = function (_a) {
    var isFetching = _a.isFetching, data = _a.data, _b = _a.props, date = _b.date, comparisonDate = _b.comparisonDate, setDate = _b.setDate, compare = _b.compare, setCompare = _b.setCompare, datePeriod = _b.datePeriod, usageResponse = _b.usageResponse, supplyInfo = _b.supplyInfo;
    var comparisonResponse = data && data[0];
    var noData = (usageResponse.electricity === null ||
        usageResponse.electricity.length === 0) &&
        (usageResponse.gas === null || usageResponse.gas.length === 0);
    return (react_1.default.createElement(UsageContent_1.UsageContent, { data: (0, utils_1.generateCombinedUsageForDatePeriod)(datePeriod, usageResponse, date, comparisonResponse, comparisonDate), date: date, setDate: setDate, compare: compare, setCompare: setCompare, datePeriod: datePeriod, comparisonDate: comparisonDate, supplyInfo: supplyInfo, noData: noData, comparisonFetching: isFetching }));
};
var DataComparison = function (_a) {
    var _b = __read(_a.data, 1), usageResponse = _b[0], _c = _a.props, accountId = _c.accountId, date = _c.date, comparisonDate = _c.comparisonDate, setDate = _c.setDate, compare = _c.compare, setCompare = _c.setCompare, datePeriod = _c.datePeriod, supplyInfo = _c.supplyInfo;
    var isComparisonEnabled = compare !== 'noComparison' && comparisonDate;
    var comparisonResponse = (0, legacy_queries_1.useUsageLegacyQuery)(accountId, comparisonDate || new Date(), // Query is disabled anyway.
    datePeriod, !isComparisonEnabled);
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { forwardProps: {
            date: date,
            setDate: setDate,
            comparisonDate: comparisonDate,
            compare: compare,
            setCompare: setCompare,
            datePeriod: datePeriod,
            usageResponse: usageResponse,
            supplyInfo: supplyInfo,
        }, queryResults: [comparisonResponse], NoData: Data, Error: Data, Data: Data }));
};
var UsageContentWithData = function (_a) {
    var accountId = _a.accountId, date = _a.date, comparisonDate = _a.comparisonDate, compare = _a.compare, setCompare = _a.setCompare, datePeriod = _a.datePeriod, setDate = _a.setDate, supplyInfo = _a.supplyInfo;
    var usageResponse = (0, legacy_queries_1.useUsageLegacyQuery)(accountId, date, datePeriod);
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { forwardProps: {
            accountId: accountId,
            date: date,
            setDate: setDate,
            comparisonDate: comparisonDate,
            compare: compare,
            setCompare: setCompare,
            datePeriod: datePeriod,
            supplyInfo: supplyInfo,
        }, queryResults: [usageResponse], NoData: __1.Loading, Error: Error, Data: DataComparison }));
};
exports.UsageContentWithData = UsageContentWithData;
